// extracted by mini-css-extract-plugin
module.exports = {"viatorProductCardImage":"providers-toristy-ToristyProductCard-ToristyProductCardImage-ToristyProductCardImage__viatorProductCardImage--h_xlH"};